import { useLocalStorage } from "@circle-react/hooks/utils/useLocalStorage";

interface UseCommentsPersistentCacheParams {
  parentCommentId: string | number | null;
  postId: string | number;
}

export const useCommentsPersistentCache = ({
  postId,
  parentCommentId,
}: UseCommentsPersistentCacheParams) => {
  const persistCacheKey = parentCommentId
    ? `post-${postId}-comment-${parentCommentId}-reply-form-values`
    : `post-${postId}-comment-form-values`;

  const { resetValue } = useLocalStorage(persistCacheKey);

  return {
    persistCacheKey,
    resetPersistedFormValues: resetValue,
  };
};
